export interface RouteLink {
  label: string;
  uri: string;
}

export const arrayToObject = (array: RouteLink[]): Record<string, string> =>
  array.reduce((obj, item) => {
    const truncatedLabel = item.label
      .slice(0, 10)
      .replace(/\s/g, "_")
      .toLowerCase();
    obj[truncatedLabel] = item.uri;
    return obj;
  }, {} as Record<string, string>); // Specify the type of the initial object as Record<string, string>

export const Routelinks: RouteLink[] = [
    {
      label: "Home",
      uri: "/",
    },
    {
      label: "About",
      uri: "/about",
    },
    {
      label: "News",
      uri: "/crypto-news",
    },
    {
      label: "Services",
      uri: "/services",
    },
    {
      label: "Contact Us",
      uri: "/contact-us",
    },
  ],
  linksObj = arrayToObject(Routelinks),
  headerLinks: RouteLink[] = [
    {
      label: "Services",
      uri: "/services",
    },
    {
      label: "About",
      uri: "/about",
    },
    {
      label: "FAQ",
      uri: "/faq",
    },
    {
      label: "Contact Us",
      uri: "/contact-us",
    },
    {
      label: "Become a service provider",
      uri: "/worker-signup",
    },
  ],
  _links: {
    contact_us: any;
    home: string;
    about: string;
    faq: string;
    services: string;
    privacy: string;
    refund: string;
    terms: string;
  } = {
    home: "/",
    about: "/about",
    faq: "/faq",
    services: "/services",
    contact_us: "/contact-us",
    privacy: "/privacy-policy",
    refund: "/refund-policy",
    terms: "/terms-and-conditions",
  },
  authLinks: {
    login: any;
    register: string;
    password_reset: string;
    forgot_password: string;
    verify_reset: string;
    verify: string;
  } = {
    login: "/login",
    register: "/register",
    forgot_password: "/forgot-password",
    password_reset: "/password/reset",
    verify_reset: "/auth/verify/reset",
    verify: "/auth/verify",
  };
